var cookieName = "refId";
var qParameter = "utm_source";
//var appUrl = "http://localhost:54128/";
var appUrl = "https://teqnavi10xhealth-as-frontend.azurewebsites.net";

var defaultWebalias = "bdawson";
var currentLocationNoRef = "";
function getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return defaultWebalias;
}
function setReferralCookie() {
    var ref = getUrlVars()[qParameter];
    if (ref != undefined) {
        var expires = "";
        var date = new Date();
        date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        document.cookie = cookieName + "=" + ref + expires + "; path=/";
    }
}

function setCookie(cName, value) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
    document.cookie = cName + "=" + value + expires + "; path=/";
}
function delay(callback, ms) {
    var timer = 0;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}
function setEnrollerSearch() {
    var referral = getCookie(cookieName).toLowerCase()
    if (referral != defaultWebalias.toLowerCase()) {
        fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ attributes: { "Referral": referral, "utm-source": referral } }),
        });
    }
}

function addUrlParameter(url, param) {
    if (url != null && url.includes("?")) {
        url = url + '&';
    } else {
        url = url + '?';
    }
    url = url + param;
    return url;
}
function removeURLParameter(url, parameter) {
    if (url != null) {
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);
            for (var i = pars.length; i-- > 0;) {
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }
            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
    }
}
function addReferralToUrl() {
    var refId = getCookie(cookieName);
    if (refId.toLowerCase() != defaultWebalias.toLowerCase()) {
        var links = document.querySelectorAll("a");

        for (var i = 0; i < links.length; i++) {
            var link = links[i].getAttribute("href");
            if (link != null) {
                var href = removeURLParameter(link, qParameter)
                links[i].href = addUrlParameter(link, qParameter + "=" + refId);
            }
        }
    }
}

function registerPDPevents() {
    var elements = document.getElementsByClassName("GT-open-form");
    for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener("click", function () {
            var container = this.closest('form');
            var patientform = container.querySelector('.patient-data-container');
            if (patientform.style.display == "none"){
              patientform.style.display = "block";
            } else {
              patientform.style.display = "none";
            }
        });
    }
}

function insertNotesCreateCustomerForm() {
    var form = document.getElementById("create_customer");
    if (form != undefined) {
        var refId = getCookie(cookieName);
        var refInput = document.createElement("input");
        refInput.setAttribute("type", "hidden");
        refInput.setAttribute("name", "customer[note][referral]");
        refInput.setAttribute("value", refId);
        form.prepend(refInput)
    }
}
function setDebugCookie() {
    var debug = getUrlVars()["debugsession"];
    if (debug != null) {
        setCookie("debugsession", debug);
    } else {
        var debugCookie = getCookie("debugsession");
        if (debugCookie == "") {
            setCookie("debugsession", "0");
        }
    }
}
function registerAffiliateForm() {
    var form = document.getElementById("affiliateSignup");
    if (form != undefined) {
        var referral = getCookie("refId");
        if (referral == null) {
            referral = defaultWebalias;
        }
        document.getElementById("Referral").value = referral;
    }
}

document.addEventListener("DOMContentLoaded", function (e) {
    var isDebug = getCookie("debugsession");
    if (isDebug == "1") {
        appUrl = "https://localhost:44348";
    }
    setDebugCookie();
    registerPDPevents();
    setReferralCookie();
    currentLocationNoRef = removeURLParameter(location.href, qParameter);
    addReferralToUrl();
    setEnrollerSearch();
    insertNotesCreateCustomerForm();
    registerAffiliateForm();
});